import axios from "axios";
import localStorageService from "./localStorageService";
import navigations from "./../navigations";
import * as appconst from './../appconst';
import jwt_decode from "jwt-decode";

export const LOGIN_ERROR = "LOGIN_ERROR";

class JwtAuthService {

  // Dummy user object just for the demo
  // user = {
  //   userId: "1",
  //   role: 'Admin',
  //   roles: ['Admin', 'A'],
  //   displayName: "Jason Alexander",
  //   email: "jasonalexander@gmail.com",
  //   photoURL: "/assets/images/face-6.jpg",
  //   age: 25,
  //   token: "faslkhfh423oiu4h4kj432rkj23h432u49ufjaklj423h4jkhkjh",
  // }

  user = {};
  token = "";


  loginWithEmailAndPassword = async (email, password) => {

    return new Promise((resolve, reject) => {

      const headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded',
      }

      axios.post(appconst.LOGIN_URL, `email=${email}&password=${password}`, {
        headers: headers
      })
        .then((response) => {
          if (response.status == 205) {
            var data = {
              Error: "User Inactive",
            }
            resolve(data);
          } else {
            console.log("RESPOSNE", response);
            var roles = [];
            roles.push(response.data.user.designation);
            // var jwtDecode = require('jwt-decode');
            var userdata = jwt_decode(response.data.access_token);
            var user = {
              userId: response.data.user.id,
              role: response.data.user.designation,
              roles: roles,
              displayName: response.data.user.name,
              email: response.data.user.email,
              // photoURL: "/assets/images/logonew.png",
              // age: 25,
              token: response.data.access_token,
              permisions: response.data.permisions
            };
            resolve(user);
          }


        })
        .catch((error) => {
          console.log("error", error)
          if (error.error == "User Inactive") {
            var data = {
              Error: "User Inactive",
            }
            resolve(data);
          } else {
            var data = {
              Error: "Invalid user credentials",
            }
            resolve(data);
          }

        })

      // resolve(user);

    }).then(data => {
      // Login successful
      // Save token
      this.setSession(data.token);
      // Set user
      this.setUser(data);
      this.setPermisions(data.permisions);

      return data;
    });
  };

  // You need to send http requst with existing token to your server to check token is valid
  // This method is being used when user logged in & app is reloaded
  loginWithToken = () => {

    return new Promise((resolve, reject) => {
      this.user = localStorageService.getItem("auth_user");
      this.token = localStorageService.getItem("token");

      const headers = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.user.token}`
        },
      };

      fetch(appconst.REFRESH, headers)
        .then(response => response.json())
        .then(data => {

          if (data.hasOwnProperty('error')) {
            console.log("invalid")
            resolve(data);
          } else {
            console.log('Token user', data)
            resolve(data);
          }
        }).catch(function () {
          var err = { error: "server error" }
          resolve(err);
        });;


    }).then(data => {
      // Token is valid

      this.setSession(data.access_token);
      this.user['token'] = data.access_token;
      localStorageService.setItem("auth_user", this.user);

      //this.setUser(data);
      return data;
    });
  };




  checkTokenValidation = async () => {
    //console.log("need to create user token validation function")
    let user = await localStorageService.getItem("auth_user");

    if (user) {
      let token_exp = jwt_decode(user.token).exp;
      let currentTime = Date.now() / 1000

      if (token_exp - currentTime < 1000) {
        this.logout();
      }
    }


  }

  //user set password
  firstTimeSetPassword = async (params, password) => {

    const a = new Promise((resolve, reject) => {
      axios.post(appconst.USER_SET_PASSWORD + params.userId + "?expires=" + params.expires + "&hash=" + params.hash + "&signature=" + params.signature, {
        "password": password
      }).then(res => {
        return resolve(res);
      })
        .catch((error) => {
          console.log(error);
          return resolve(error);
        })
    });

    return await a;
  }


  logout = () => {
    this.setSession(null);
    this.removeUser();
  }

  // Set token to all http request header, so you don't need to attach everytime
  setSession = token => {
    if (token) {

      axios.defaults.headers.common["Authorization"] = "Bearer " + token;
      localStorage.setItem("jwt_token", token);

    } else {
      localStorage.removeItem("jwt_token");
      delete axios.defaults.headers.common["Authorization"];
    }
  };

  // Save user to localstorage
  setUser = (user) => {
    if (user.Error) {
      return;
    } else {
      localStorageService.setItem("auth_user", user);
    }
  }

  setPermisions = (data) => {
    if (data != undefined) {
      localStorageService.setItem("auth_user_permisions", data);
    }

  }

  //Get user from localstorage
  getUser = async (user) => {
    return await localStorageService.getItem("auth_user");
  }
  // Remove user from localstorage
  removeUser = () => {
    localStorage.removeItem("auth_user");
    localStorage.removeItem("auth_user_permisions");
  }
}

export default new JwtAuthService();
